export default __webpack_public_path__ + "static/media/COVID-Icons-5.8296b6a9.svg";